<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M12.518 23.217c5.91 0 10.7-4.79 10.7-10.7 0-5.91-4.79-10.7-10.7-10.7-5.91 0-10.7 4.79-10.7 10.7 0 5.91 4.79 10.7 10.7 10.7Z"
    />
    <path
      d="M16.657 18.012v.05h-5.5v-.05h5.5Zm.005-2.099v.05h-5.097a.603.603 0 0 1-.243-.05h5.34ZM9.315 7.866V9.89l.022.07 1.709 5.599.061.2a.594.594 0 0 1-.092-.134l-.038-.097-1.711-5.766V7.866h.05Zm5.425 0h1.245c.193 0 .343.064.476.203a.71.71 0 0 1 .201.522v3.148a.709.709 0 0 1-.201.522.614.614 0 0 1-.476.203H14.74a.665.665 0 0 1-.5-.21.692.692 0 0 1-.212-.515V8.591c0-.211.068-.373.21-.514l.001-.002a.661.661 0 0 1 .358-.196l.143-.013Zm-.162.05v.021a.653.653 0 0 0-.212.096l-.093.08a.67.67 0 0 0-.195.478v3.148c0 .168.058.331.182.465l.006.007.007.007a.656.656 0 0 0 .467.196h1.245a.61.61 0 0 0 .506-.265c.1-.144.121-.3.121-.41V8.591a.72.72 0 0 0-.111-.396l-.01-.013-.046-.06a.609.609 0 0 0-.333-.193v-.013h-1.534Z"
    />
  </svg>
</template>
